import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Vessels = ({ roles }) => {

    return (
        <M_Table entityName={'Vessel'} filtersOnTable rolePermissions={roles} />
    )
}